import { render, staticRenderFns } from "./LineElement.vue?vue&type=template&id=2c6c62e6&scoped=true&"
import script from "./LineElement.vue?vue&type=script&lang=js&"
export * from "./LineElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c62e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c6c62e6')) {
      api.createRecord('2c6c62e6', component.options)
    } else {
      api.reload('2c6c62e6', component.options)
    }
    module.hot.accept("./LineElement.vue?vue&type=template&id=2c6c62e6&scoped=true&", function () {
      api.rerender('2c6c62e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Elements/LineElement.vue"
export default component.exports